import { DialogTitle, Box, Typography, TextField, Button, InputAdornment, IconButton, Grid2, useTheme, useMediaQuery, Paper, BottomNavigation, BottomNavigationAction, Dialog, DialogContent, DialogActions, Fab, Stepper, Step, StepLabel } from "@mui/material";
import { PersonSearch, MyLocation, AccessTime, Restaurant, Close, Sync } from "@mui/icons-material";
import { forwardRef, useEffect, useState } from "react"
import { useSnackbar } from "./context/SnackbarContext";
import { useLoader } from "./context/LoaderContext";
import FechaHora from "./components/FechaHora";
import ImgDefault from './assets/personal-default.jpg';
import useUbicacion from "./hooks/useUbicacion";

const RegistroAsistencia = ()=>{
  const [dni, setDni] = useState('');
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm")); // controlar la visualizacion de componentes en modo responsive. true si pantalla ≥ sm
  const {showSnackbar} = useSnackbar();// Provider de Alertas
  const {showLoader, hideLoader} = useLoader(); //Provider de Loader
  const [persona, setPersona] = useState(null); //Controla el estado de la informacion del empleado
  const [open, setOpen] = useState(false); //Controla el estado del modal
  const [foto, setFoto] = useState(false); //Controla el boton de actualizacion de la foto
  const {ubicacion, actualizarUbicacion} = useUbicacion(); //Controla el acceso al hub de ubicacion
  const [imagenBase64, setImagenBase64] = useState(null); //Controla la visualizacion de la foto. Por defecto es personal-default.jpg
  const [marcador, setMarcador] = useState({tipo:null, latitud:null, longitud:null, direccion:null}); //Controla el estado de la informacion de las coordenadas
  const [tipos, setTipos]=useState({labIngreso:true, labSalida:true, refIngreso:true, refSalida:true}); //Controla las posibles combinaciones de estado de los botones segun la marcacion de la BD
  const [botones, setBotones] = useState({asistencia:true, refrigerio:true, ingreso:true, salida:true, nombre:''});//Controla el estado actual de los 4 botones
  const [etiquetas, setEtiquetas] = useState({fecha:null, horario:null, labingreso:null, refingreso:null, refsalida:null, labsalida:null}); //Controla la visualizacion de las etiquetas informativas de la ultima marcacion

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const ejecutarUbicacion = async()=> {
      showLoader();
      try {
        await actualizarUbicacion();
      } catch (ex) {
        showSnackbar({message:`Error al obtener ubicación: ${ex.message}`, severity:'error' });
      } finally {
        hideLoader();
      }
    };  
    ejecutarUbicacion();
  }, [actualizarUbicacion, showSnackbar, showLoader, hideLoader]);

  useEffect(()=>{
    if(ubicacion.estado){
      setMarcador((prev)=>({
        ...prev,
        latitud:ubicacion.latitud,
        longitud:ubicacion.longitud,
        direccion:ubicacion.direccion
      }));
    }
  },[ubicacion]);

  const obtenerUbicacionConLoader = async()=> {
    showLoader();
    try {
      await actualizarUbicacion();
    } catch (ex) {
      showSnackbar({message:`Error al obtener ubicación: ${ex.message}`, severity:'error' });
    } finally {
      hideLoader();
    }
  };

  const buscarPersonaFoto = async(nombre)=>{
    try{
      console.log(API_BASE_URL);
      const response = await fetch(`${API_BASE_URL}/ghu/download/ApiDescargarEmpleadoFoto.php`,{
        method:'POST',
        headers:{
          'Content-type':'application/json'
        },
        body:JSON.stringify({nombre})
      });//.then(response=>response.text()).then((response)=>{console.log(response)}).catch(err=>console.log(err));

      if (!response.ok) { throw new Error(`${response.status} ${response.statusText}`); }      
      const datos = await response.json();
      if (!datos.res) { throw new Error(`${datos.msg}`); }

      setImagenBase64(`data:${datos.tipo};base64,${datos.archivo}`);
    }catch(ex){
      throw ex;
    }
  };

  const mostrarEtiquetas=async(marcacion)=>{

    let etiqueta={
      labIngreso:false,
      labSalida:false,
      refIngreso:false,
      refSalida:false
    }

    if(marcacion.labingreso){
      etiqueta.labIngreso=true;
    }

    if(marcacion.labsalida){
      etiqueta.labSalida=true;
    }

    if(marcacion.refingreso){
      etiqueta.refIngreso=true;
    }

    if(marcacion.refsalida){
      etiqueta.refSalida=true;
    }

    setEtiquetas({
      fecha: marcacion.fecha,
      horario: marcacion.hornombre,
      labingreso: etiqueta.labIngreso,
      labsalida: etiqueta.labSalida,
      refingreso: etiqueta.refIngreso,
      refsalida: etiqueta.refSalida
    });
  }

  const buscarUltimaMarcacion = async(perid)=>{
    try{
      const response = await fetch(`${API_BASE_URL}/ghu/search/ApiBuscarMarcacionUltima2.php`,{
        method:'POST',
        headers:{
          'Content-type':'application/json'
        },
        body:JSON.stringify({perid})
      });//.then(response=>response.text()).then((response)=>{console.log(response)}).catch(err=>console.log(err));
      
      if (!response.ok) { throw new Error(`${response.status} ${response.statusText}`); }      
      const datos = await response.json();
      if (!datos.res) { throw new Error(`${datos.msg}`); }

      mostrarEtiquetas(datos.data);
    }catch(ex){
      throw ex;
    }    
  }

  const submitBuscarPersona = async(e)=>{
    e.preventDefault();
    try{
      if(dni.length===8){
        if(ubicacion.estado){
          await buscarMarcacion(dni);
          setDni('');
        }else{
          showSnackbar({message: 'LA UBICACION ES INCORRECTA', severity:'warning' });
        }
      }else{
        showSnackbar({message: 'EL DNI ES INCORRECTO', severity:'warning' });
        setPersona(null);
        setEtiquetas({fecha:null, horario:null, labingreso:null, refingreso:null, refsalida:null, labsalida:null});
        setBotones({asistencia:true, refrigerio:true, ingreso:true, salida:true, nombre:''});
        setTipos({labIngreso:true, labSalida:true, refIngreso:true, refSalida:true});
        setImagenBase64(null);
      }
    }catch(ex){
      showSnackbar({message: ex.message, severity:'error' });
      setDni('');
      setPersona(null);
      setEtiquetas({fecha:null, horario:null, labingreso:null, refingreso:null, refsalida:null, labsalida:null});
      setBotones({asistencia:true, refrigerio:true, ingreso:true, salida:true, nombre:''});
      setTipos({labIngreso:true, labSalida:true, refIngreso:true, refSalida:true});
      setImagenBase64(null);
    }
  }

  const buscarMarcacion = async(dni)=>{
    try{
      const response = await fetch(`${API_BASE_URL}/ghu/search/ApiBuscarEmpleadoMarcacionUltima2.php`,{
        method:'POST',
        headers:{
          'Content-type':'application/json'
        },
        body:JSON.stringify({dni})
      });//.then(response=>response.text()).then((response)=>{console.log(response)}).catch(err=>console.log(err));
      if (!response.ok) { throw new Error(`${response.status} ${response.statusText}`); }      
      const datos = await response.json();
      if (!datos.res) { throw new Error(`${datos.msg}`); }

      setImagenBase64(null);
      setPersona(datos.data.empleado);
      mostrarEtiquetas(datos.data.marcacion);

      if(datos.data.empleado.foto){
        setFoto(true);
      }

      let estadoBotones={
        asistencia:true,
        refrigerio:true,
        asistenciaIngreso:true,
        asistenciaSalida:true,
        refrigerioIngreso:true,
        refrigerioSalida:true
      }

      if(datos.data.empleado.id>0){
        estadoBotones.asistencia=false;
      }

      if(Number(datos.data.marcacion.tecestado)===1){
        estadoBotones.asistenciaSalida=false;

        if(!datos.data.marcacion.refsalida){
          estadoBotones.refrigerio=false;
          estadoBotones.refrigerioSalida=false;
          if(!datos.data.marcacion.refingreso){
            estadoBotones.refrigerioIngreso=false;
          }
        }
      }else if(Number(datos.data.marcacion.tecestado)===2){
        estadoBotones.asistenciaIngreso=false;
      }else{
        estadoBotones.asistenciaIngreso=false;
      }

      setBotones((prev)=>({
        ...prev,
        asistencia:estadoBotones.asistencia,
        refrigerio:estadoBotones.refrigerio
      }));

      setTipos((prev)=>({
        ...prev,
        labIngreso:estadoBotones.asistenciaIngreso,
        labSalida:estadoBotones.asistenciaSalida,
        refIngreso:estadoBotones.refrigerioIngreso,
        refSalida:estadoBotones.refrigerioSalida
      }));      

    }catch(ex){
      throw ex;
    }
  }

  const agregarTipo=(tipo)=>{
    try{
      setMarcador((prev)=>({
        ...prev,
        tipo:tipo
      }));

      if(tipo==='ASI'){
        setBotones((prev)=>({
          ...prev,
          ingreso:tipos.labIngreso,
          salida:tipos.labSalida,
          nombre:'LABORES'
        }));
      }else if(tipo==='REF'){
        setBotones((prev)=>({
          ...prev,
          ingreso:tipos.refIngreso,
          salida:tipos.refSalida,
          nombre:'REFRIGERIO'
        }));
      }
      setOpen(true);
    }catch(ex){
      showSnackbar({message: ex.message, severity:'error' });
    }
  }

  const agregarMarcacion=async(forma)=>{
    showLoader();
    try{
      const response = await fetch(`${API_BASE_URL}/ghu/insert/ApiAgregarMarcaciones2.php`,{
        method:'POST',
        headers:{
          'Content-type':'application/json'
        },
        body:JSON.stringify({
          'perid': persona.id,
          'tipo': marcador.tipo,
          'forma': forma,
          'latitud': marcador.latitud,
          'longitud': marcador.longitud,
          'direccion': marcador.direccion
        })
      });//.then(response=>response.text()).then((response)=>{console.log(response)}).catch(err=>console.log(err));
      if (!response.ok) { throw new Error(`${response.status} ${response.statusText}`); }      
      const datos = await response.json();
      if (!datos.res) { throw new Error(`${datos.msg}`); }
      
      await buscarUltimaMarcacion(persona.id);

      showSnackbar({message:datos.msg, severity:'success'});
    }catch(ex){
      showSnackbar({message: ex.message, severity:'error' });
    }finally{
      hideLoader();
      setTipos((prev)=>({
        ...prev,
        labIngreso:true,
        labSalida:true,
        refIngreso:true,
        refSalida:true
      }));
      setBotones((prev)=>({
        ...prev,
        asistencia:true,
        refrigerio:true,
        ingreso:true,
        salida:true,
        nombre:''
      }));
      setOpen(false);
    }
  };

  const buscarFoto=async()=>{
    try{
      setFoto(false);
      if(persona.foto){
        await buscarPersonaFoto(persona.foto);
      }else{
        showSnackbar({message:'NO SE RECONOCE EL NOMBRE DE LA IMAGEN', severity:'warning' });
      }   
    }catch(ex){
      showSnackbar({message: ex.message, severity:'error' });
    }
  };

  const handleChangeDni=(e) => {
    const value = e.target.value;
    if (/^\d{0,8}$/.test(value)) {
      setDni(value);
    }
  };

  const handleClose=()=>{
    setOpen(false);
  };

  //Componente para personalizar el modal y evitar el parpadeo cuando interactua con el Snackbar Alert
  const NoTransition = forwardRef(function NoTransition(props, ref) {  
    const {
      appear,
      in: inProp,
      onEnter,
      onExited,
      ownerState,
      className,
      style,
      children,
      ...other
    } = props;
    
    return (
      <div
        ref={ref}
        className={className}
        style={{
          position: 'fixed',
          zIndex: -1,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.5)',
          ...style,
        }}
        {...other} // este 'other' ya no incluye ownerState
      >
        {children}
      </div>
    );
  });

  return(
    <Box sx={{mt:2, p:2, border: "1px solid #ccc", borderRadius: 2, position:'relative' }}>

      <Grid2 container spacing={2} sx={{mb:1}}>
        <Grid2 size={{xs:8, sm:6}}>
          <Box
            component="img"
            src="/logo-gpem.png"
            alt="Imagen en base64"
            sx={{ maxHeight: 60, objectFit: "cover" }}>
          </Box>
        </Grid2>
        <Grid2 size={{xs:4, sm:6}} sx={{display:'flex', alignItems:'center', justifyContent:'end'}}>
          <FechaHora/>
        </Grid2>
      </Grid2>
      
      {/**
      <Grid2 container>
        <Grid2 size={12}>
          <Typography variant="h5" mb={2} sx={{textAlign:'center'}}>CONTROL DE ASISTENCIA</Typography>          
        </Grid2>
      </Grid2>
      */}

      <Grid2 container sx={{mb:3}}>
        <Grid2 size={12} sx={{display:'flex', justifyContent:'center'}}>
          <Box component="form" onSubmit={submitBuscarPersona} sx={{width:'100%', textAlign:'center'}}>
            <TextField
              label="Ingrese su DNI"
              variant="standard"
              color="success"
              value={dni}
              onChange={handleChangeDni}
              fullWidth
              slotProps={{
                input:{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton type="submit" edge="end" color="success">
                        <PersonSearch fontSize="large"/>
                      </IconButton>
                    </InputAdornment>
                  )
                }
              }}
              sx={{maxWidth:400, input:{fontWeight:'bold', fontSize:'25px', textAlign:'center', py:0}}}
            />
          </Box>          
        </Grid2>
      </Grid2>

      <Grid2 container spacing={2} sx={{mb:1}}>
        {/* Imagen, oculta en xs */}
        {isSmUp && (
          <Grid2 size={{xs:12, sm:4}} sx={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <Box sx={{position:'relative', width:'100%', display:'flex', justifyContent:'center'}}>
              <Box
                component="img"
                src={imagenBase64 || ImgDefault}
                alt="Imagen en base64"
                sx={{ maxWidth: "100%", maxHeight: 200, objectFit: "cover" }}
              >
              </Box>
              {foto && (
                <IconButton onClick={buscarFoto} color="secondary" sx={{position:'absolute', top:'50%', left:'50%', transform: 'translate(-50%, -50%)', zIndex:1}}>
                  <Sync sx={{fontSize:40}}/>
                </IconButton>
              )}
            </Box>
          </Grid2>
        )}
        <Grid2 size={{xs:12, sm:8}}>
          {isSmUp && (
            <>
              <TextField id="filled-basic" size="small" label="CODIGO" variant="filled" fullWidth sx={{marginBottom:1}} value={persona?.id || ''} slotProps={{input:{readOnly:true}}} />
              <TextField id="filled-basic" size="small" label="DNI" variant="filled" fullWidth sx={{marginBottom:1}} value={persona?.dni || ''} slotProps={{input:{readOnly:true}}} />
            </>
          )}
          <TextField id="filled-basic" size="small" label="NOMBRES" variant="filled" fullWidth sx={{marginBottom:1}} value={persona?.nombres || ''} slotProps={{input:{readOnly:true}}} />
          <TextField id="filled-basic" size="small" label="APELLIDOS" variant="filled" fullWidth sx={{marginBottom:1}} value={persona?.apellidos || ''} slotProps={{input:{readOnly:true}}} />
        </Grid2>
      </Grid2>

      <Grid2 container sx={{mb:2}}>
        <Grid2 size={12} sx={{borderBottom:1, borderColor:'#c0c0c0', mb:2}}>
          <Typography sx={{fontWeight:'bold'}}>Último Registro</Typography>
        </Grid2>
        <Grid2 size={6} sx={{textAlign:'center'}}>
          <Typography sx={{fontSize:isSmUp?16:12}}><span style={{fontWeight:'bold'}}>Fecha: </span>{etiquetas.fecha?etiquetas.fecha:'-*-'}</Typography>
        </Grid2>
        <Grid2 size={6} sx={{textAlign:'center'}}>
          <Typography sx={{fontSize:isSmUp?16:12}}><span style={{fontWeight:'bold'}}>Horario: </span>{etiquetas.horario?etiquetas.horario:'-*-'}</Typography>
        </Grid2>
      </Grid2>
      
      <Grid2 container sx={{mb:2}}>
        <Grid2 size={12} sx={{borderBottom:1, borderColor:'#c0c0c0', pb:1}}>
          <Stepper activeStep={-1} alternativeLabel>
            <Step>
               <StepLabel icon={<AccessTime sx={{color:etiquetas.labingreso?'blue':'#c0c0c0', fontSize:30}}/>} sx={{'& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':{mt:0, color:etiquetas.labingreso?'black':'#c0c0c0'}}}>Ingreso <br/> Labores</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<Restaurant sx={{color:etiquetas.refingreso?'orange':'#c0c0c0', fontSize:30}}/>} sx={{'& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':{mt:0, color:etiquetas.refingreso?'black':'#c0c0c0'}}}>Ingreso <br/> Refrigerio</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<Restaurant sx={{color:etiquetas.refsalida?'orange':'#c0c0c0', fontSize:30}}/>} sx={{'& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':{mt:0, color:etiquetas.refsalida?'black':'#c0c0c0'}}}>Salida <br/> Refrigerio</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<AccessTime sx={{color:etiquetas.labsalida?'blue':'#c0c0c0', fontSize:30}}/>} sx={{'& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':{mt:0, color:etiquetas.labsalida?'black':'#c0c0c0'}}}>Salida <br/> Labores</StepLabel>
            </Step>
          </Stepper>
        </Grid2>
      </Grid2>

      {/*
      <Grid2 container spacing={1} sx={{mb:2}}>
        <Grid2 size={3} sx={{backgroundColor:etiquetas.labingreso?'blue':'#c0c0c0', py:2, display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Box>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>INGRESO</Typography>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>LABORES</Typography>
          </Box>
        </Grid2>
        <Grid2 size={3} sx={{backgroundColor:etiquetas.refingreso?'orange':'#c0c0c0', py:2, display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Box>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>INGRESO</Typography>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>REFRIGERIO</Typography>
          </Box>
        </Grid2>
        <Grid2 size={3} sx={{backgroundColor:etiquetas.refsalida?'orange':'#c0c0c0', py:2, display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Box>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>SALIDA</Typography>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>REFRIGERIO</Typography>
          </Box>
        </Grid2>
        <Grid2 size={3} sx={{backgroundColor:etiquetas.labsalida?'blue':'#c0c0c0', py:2, display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Box>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>SALIDA</Typography>
            <Typography sx={{textAlign:'center', color:'white', fontSize:isSmUp?16:12}}>LABORES</Typography>
          </Box>
        </Grid2>
      </Grid2>
      */}
      
      
      <Grid2 container sx={{mb:2}}>
        {/**
         <Grid2 size={2} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          <IconButton onClick={obtenerUbicacionConLoader} edge="end" color="primary" sx={{p:0, m:0}}>
            <MyLocation fontSize="large"/>
          </IconButton>
        </Grid2>
        */}

        <Grid2 size={12}>
          <Typography sx={{fontWeight:'bold'}}>Mi Ubicación</Typography>
          <Typography sx={{minHeight:50}}>{marcador.direccion}</Typography>
        </Grid2>
      </Grid2>

      {isSmUp ? (
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <Button variant="outlined" size="large" color="success" sx={{py:2, fontWeight:'bold', fontSize:'1rem'}} startIcon={<AccessTime style={{fontSize:25}}/>} fullWidth onClick={()=>agregarTipo('ASI')} disabled={botones.asistencia}>ASISTENCIA</Button>
          </Grid2>
          <Grid2 size={6}>
            <Button variant="outlined" size="large" color="warning" sx={{py:2, fontWeight:'bold', fontSize:'1rem'}} startIcon={<Restaurant style={{fontSize:22}}/>} fullWidth onClick={()=>agregarTipo('REF')} disabled={botones.refrigerio}>REFRIGERIO</Button>
          </Grid2>
        </Grid2>
      ):(
        <Paper sx={{ position:'fixed', bottom:0, left:0, right:0 }} elevation={3}>
          <BottomNavigation showLabels sx={{py:1.5}}>
            <BottomNavigationAction label="ASISTENCIA" icon={<AccessTime sx={{fontSize:30}}/>} sx={{fontWeight:'bold', color:botones.asistencia?'gray':'blue', '& .MuiBottomNavigationAction-label':{fontSize:'1.1rem'}}} onClick={()=>(agregarTipo('ASI'))} disabled={botones.asistencia} />
            <BottomNavigationAction label="REFRIGERIO" icon={<Restaurant sx={{fontSize:30}}/>} sx={{fontWeight:'bold', color:botones.refrigerio?'gray':'orange', '& .MuiBottomNavigationAction-label':{fontSize: '1.1rem'}}} onClick={()=>(agregarTipo('REF'))} disabled={botones.refrigerio} />
          </BottomNavigation>
        </Paper>
      )}

      <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth TransitionComponent={NoTransition} slots={{backdrop:NoTransition}} slotProps={{backdrop:{style:{backgroundColor:'rgba(0,0,0,0.5)', transition:'none'}}}} closeAfterTransition={false} disableScrollLock>
        <DialogTitle sx={{m:0, p:2, fontSize:17, fontWeight:'bold'}}>OPCIONES DE MARCADO</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={(theme)=>({position:'absolute', right:4, top:4, color:theme.palette.grey[500] })}>
          <Close sx={{fontSize:30}}/>
        </IconButton>        
        <DialogContent dividers>
          <Grid2 container spacing={2}>
            <Grid2 size={6}>
              <Button variant="contained" color="success" sx={{fontSize:16, fontWeight:'bold'}} disabled={botones.ingreso} fullWidth onClick={()=>agregarMarcacion('ING')}>INGRESO <br/> {botones.nombre}</Button>
            </Grid2>
            <Grid2 size={6}>
              <Button variant="contained" color="error" sx={{fontSize:16, fontWeight:'bold'}} disabled={botones.salida} fullWidth onClick={()=>agregarMarcacion('SAL')}>SALIDA <br/> {botones.nombre}</Button>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{fontWeight:'bold'}} >CANCELAR</Button>
        </DialogActions>
      </Dialog>

      <Fab size="small" color="secondary" sx={{position:'absolute', bottom:isSmUp?130:70, right:16}} onClick={obtenerUbicacionConLoader}>
        <MyLocation></MyLocation>
      </Fab>

    </Box>
  );
};

export default RegistroAsistencia;